(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beanited-learning-article"]) return;
  try {
    
function initBeanitedArticles(root) {
  root.querySelectorAll('[data-ba-copy]').forEach(button => {
    if (!navigator.clipboard || button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.hidden = false;
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-ba-status]');
      try { await navigator.clipboard.writeText(button.dataset.baCopy); status.textContent = 'Article link copied.'; }
      catch { status.textContent = 'Could not copy. Please copy the address from your browser.'; }
    });
  });
  root.querySelectorAll('[data-ba-video]').forEach(details => {
    if (details.dataset.ready) return;
    details.dataset.ready = 'true';
    details.addEventListener('toggle', () => {
      const template = details.querySelector('template');
      if (details.open && !details.querySelector('iframe')) details.append(template.content.cloneNode(true));
      if (!details.open) details.querySelector('iframe')?.remove();
    });
  });
}
initBeanitedArticles(document);
document.addEventListener('shopify:section:load', event => initBeanitedArticles(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beanited-save-lesson"] && !Shopify.designMode) return;
  try {
    
const BEANITED_SAVED_LEARNING_TOKEN_KEY='beanited:saved-learning-token';
function readBeanitedSavedLearningToken(){try{const value=JSON.parse(sessionStorage.getItem(BEANITED_SAVED_LEARNING_TOKEN_KEY)||'null');if(!value||typeof value.accessToken!=='string'||Date.now()>=value.expiresAt){sessionStorage.removeItem(BEANITED_SAVED_LEARNING_TOKEN_KEY);return null}return value.accessToken}catch{sessionStorage.removeItem(BEANITED_SAVED_LEARNING_TOKEN_KEY);return null}}
function authenticateBeanitedSavedLearning(apiOrigin){return new Promise((resolve,reject)=>{const authUrl=new URL('/api/shopify/customer-account/start',apiOrigin);authUrl.searchParams.set('origin',window.location.origin);const popup=window.open(authUrl.toString(),'beanited-saved-learning-auth','popup,width=520,height=720');if(!popup){reject(new Error('authentication_popup_blocked'));return}const timeout=window.setTimeout(()=>{window.removeEventListener('message',receiveToken);reject(new Error('authentication_timed_out'))},120000);function receiveToken(event){if(event.origin!==apiOrigin||event.source!==popup)return;if(event.data?.type!=='beanited:saved-learning-auth')return;window.clearTimeout(timeout);window.removeEventListener('message',receiveToken);if(!event.data.ok||typeof event.data.accessToken!=='string'){reject(new Error('authentication_failed'));return}const expiresIn=Number(event.data.expiresIn);sessionStorage.setItem(BEANITED_SAVED_LEARNING_TOKEN_KEY,JSON.stringify({accessToken:event.data.accessToken,expiresAt:Date.now()+Math.max(0,expiresIn-60)*1000}));resolve(event.data.accessToken)}window.addEventListener('message',receiveToken)})}
function initBeanitedSaveLesson(root){root.querySelectorAll('[data-ba-save-host]').forEach(host=>{if(host.dataset.ready)return;host.dataset.ready='true';const button=host.querySelector('[data-ba-save-button]');const label=host.querySelector('[data-ba-save-label]');const status=host.querySelector('[data-ba-save-status]');const apiOrigin=new URL(host.dataset.apiOrigin).origin;const endpoint=`${apiOrigin}/api/shopify/proxy/saved-learning`;const share=document.querySelector('.beanited-learning-section .ba-share');if(!button||!label||!status||!share)return;const shareLabel=share.firstElementChild;if(shareLabel)shareLabel.after(host);else share.prepend(host);host.hidden=false;const setSaved=saved=>{button.dataset.saved=saved?'true':'false';button.setAttribute('aria-pressed',saved?'true':'false');button.classList.toggle('is-saved',saved);label.textContent=saved?host.dataset.labelSaved:host.dataset.labelSave};const goToLogin=()=>{const loginUrl=host.dataset.loginUrl;if(loginUrl)window.location.assign(loginUrl)};const loadState=async()=>{if(host.dataset.shopifyCustomerPresent!=='true'){sessionStorage.removeItem(BEANITED_SAVED_LEARNING_TOKEN_KEY);host.dataset.authenticated='false';label.textContent=host.dataset.labelLogin;return}const accessToken=readBeanitedSavedLearningToken();if(!accessToken){host.dataset.authenticated='false';return}button.disabled=true;try{const params=new URLSearchParams({resource_type:host.dataset.resourceType,resource_id:host.dataset.resourceId});const response=await fetch(`${endpoint}?${params.toString()}`,{headers:{Accept:'application/json',Authorization:`Bearer ${accessToken}`}});const body=await response.json().catch(()=>({}));if(response.status===401&&body.error==='login_required'){sessionStorage.removeItem(BEANITED_SAVED_LEARNING_TOKEN_KEY);host.dataset.authenticated='false';label.textContent=host.dataset.labelLogin;return}if(!response.ok||!body.ok)throw new Error(body.error||'saved_learning_status_failed');host.dataset.authenticated='true';setSaved(Boolean(body.saved))}catch{host.dataset.authenticated='unknown';status.textContent=host.dataset.statusError}finally{button.disabled=false}};button.addEventListener('click',async()=>{if(host.dataset.authenticated==='false'&&host.dataset.shopifyCustomerPresent!=='true'){goToLogin();return}const shouldSave=button.dataset.saved!=='true';button.disabled=true;try{const accessToken=readBeanitedSavedLearningToken()||await authenticateBeanitedSavedLearning(apiOrigin);const response=await fetch(endpoint,{method:'POST',headers:{Accept:'application/json',Authorization:`Bearer ${accessToken}`,'Content-Type':'application/json'},body:JSON.stringify({action:shouldSave?'save':'remove',resourceType:host.dataset.resourceType,resourceId:host.dataset.resourceId,resourceHandle:host.dataset.resourceHandle,resourceUrl:host.dataset.resourceUrl})});const body=await response.json().catch(()=>({}));if(response.status===401&&body.error==='login_required'){sessionStorage.removeItem(BEANITED_SAVED_LEARNING_TOKEN_KEY);host.dataset.authenticated='false';throw new Error('authentication_expired')}if(!response.ok||!body.ok)throw new Error(body.error||'saved_learning_update_failed');host.dataset.authenticated='true';setSaved(Boolean(body.saved));status.textContent=body.saved?host.dataset.statusSaved:host.dataset.statusRemoved}catch{status.textContent=host.dataset.statusError}finally{button.disabled=false}});loadState()})}
initBeanitedSaveLesson(document);document.addEventListener('shopify:section:load',event=>initBeanitedSaveLesson(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
